interface Props {
  variant?: "card" | "list" | "text";
  lines?: number;
  className?: string;
}

export function SkeletonLoader({ variant = "text", lines = 3, className = "" }: Props) {
  if (variant === "card") {
    return (
      <div role="status" aria-label="Loading" className={`rounded-2xl h-48 w-full bg-gray-200 shimmer ${className}`} />
    );
  }

  if (variant === "list") {
    const widths = ["w-full", "w-5/6", "w-4/5", "w-3/4", "w-2/3"];
    return (
      <div role="status" aria-label="Loading" className={`space-y-3 ${className}`}>
        {Array.from({ length: lines }).map((_, i) => (
          <div key={i} className={`h-4 rounded-lg bg-gray-200 shimmer ${widths[i % widths.length]}`} />
        ))}
      </div>
    );
  }

  // text
  return (
    <div role="status" aria-label="Loading" className={`h-4 w-full rounded-lg bg-gray-200 shimmer ${className}`} />
  );
}
